import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { ISetLabelsAction } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { Messages } from '../../../codegen/Localize';
import { setAiLabelAction } from '../../actions/labels/SetAiLabelAction';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const SetAiLabelEntityAction: IEntityAction<IContentInfo, ISetLabelsAction> = {
    name: EntityActionNames.SetAiDataLabel,
    translateName: Messages.editAiLabelAction,
    isVisible: (items, state) => selectCatalogingOnSiteEnabled(state),
    isClickable: (availableActions: ISetLabelsAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
    createReduxAction: (items) => setAiLabelAction(items[0])
};
